module.exports = __webpack_public_path__ + "static/img/14a.507e488.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14a.jpg
// module id = 1uBc
// module chunks = 0